module.exports = __webpack_public_path__ + "static/media/NotoSansCJKkr-Bold.79d613fb.woff";